export default __webpack_public_path__ + "static/media/blog_inner_19.18503fb1.jpg";